import * as React from "react";
import classNames from "classnames";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";
import { Dispatch } from "redux";
import { connect } from "react-redux";

import IconButton from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import CloseIcon from "@material-ui/icons/Close";
import { formatDate } from "../../util/date-utility";
import { Reservation } from "../../api/reservations";
import { Table } from "../../api/tables";
import { StoreState } from "../../reducers/root-reducer";
import { setMovingReservation } from "../../actions/store/planner-list-actions";
import { ConnectedInfobar } from "../layout/infobar";

interface State {
	id: string;
	date: Date;
	peopleCount: number;
	primaryName: string;
}

export interface PlannerListMovingReservationProps {}

interface ConnectedPlannerListMovingReservationProps
	extends WithStyles<typeof styles> {
	reservations: Reservation[];
	movingReservationId: string;
	setMovingReservation: (id: string) => void;
}

type Props = PlannerListMovingReservationProps &
	ConnectedPlannerListMovingReservationProps;

export class PlannerListMovingReservation extends React.Component<
	Props,
	State
> {
	public state: State = {
		id: null,
		date: null,
		peopleCount: null,
		primaryName: null
	};

	public componentDidMount() {
		this.setStateFromProps(this.props);
	}

	public componentWillReceiveProps(nextProps: Props) {
		this.setStateFromProps(nextProps);
	}

	private setStateFromProps = (props: Props) => {
		const { movingReservationId, reservations } = props;

		if (movingReservationId && movingReservationId !== this.state.id) {
			const reservation = reservations.find(
				res => res.id === movingReservationId
			);

			if (reservation) {
				const { id, date, peopleCount, primaryName } = reservation;

				this.setState({ id, date, peopleCount, primaryName });
			}
		}
	};

	private handleCancelClick = () => {
		this.props.setMovingReservation(null);
	};

	public render() {
		const { classes, movingReservationId } = this.props;
		const { date, peopleCount, primaryName } = this.state;

		return (
			<ConnectedInfobar
				visible={Boolean(movingReservationId)}
				renderSaveButton={false}
				onCancelClick={this.handleCancelClick}
				rootClass={classes.infobar}
				zIndex={15}
			>
				<div className={classes.infobarContent}>
					<Avatar className={classes.infobarAvatar}>
						{peopleCount}
					</Avatar>
					<Typography className={classes.infobarTitle}>
						{primaryName}
					</Typography>
				</div>
			</ConnectedInfobar>
		);
	}
}

const mapStateToProps = (state: StoreState) => ({
	reservations: state.reservations,
	movingReservationId: state.plannerListMovingReservation
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	setMovingReservation: (id: string) => dispatch(setMovingReservation(id))
});

const styles = (theme: Theme) =>
	createStyles({
		infobar: {
			height: 100,
			transform: "translate3d(0, 110%, 0)",
			top: "auto",
			bottom: 0
		},
		infobarContent: {
			display: "flex",
			alignItems: "center"
		},
		infobarAvatar: {
			marginRight: 15
		},
		infobarTitle: {
			fontWeight: 500
		}
	});

export const ConnectedPlannerListMovingReservation = withStyles(styles)(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(PlannerListMovingReservation)
);
